{
  "info": "معلومات",
  "negative": "خطأ",
  "positive": "تم بنجاح"
}
